<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col">
                <h3>{{ `${isUpdate ? 'Chỉnh sửa ngày nghỉ lễ' : 'Thêm ngày nghỉ lễ'}` }}</h3>
            </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full md:w-1/3">
                <label class="vs-input--label">Chi nhánh</label>
                <span class="text-danger">*</span>
                <v-select v-model="branchModel" :options="branchOptions" v-validate="'required'" :clearable="false"
                          :disabled="isUpdate" name="Chi nhánh">
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('Chi nhánh') }}</span>
            </div>
        </div>
        <h5 class="mt-6">Ngày nghỉ:</h5>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/3 mt-2">
                <label class="vs-input--label">Tên ngày nghỉ</label>
                <span class="text-danger">*</span>
                <vs-input class="w-full" v-model="holiday.holidayName" v-validate="'required'" name="Tên ngày nghỉ">
                </vs-input>
                <span class="text-danger text-sm">{{ errors.first('Tên ngày nghỉ') }}</span>
            </div>
            <div class="vx-col w-full md:w-1/3 mt-2">
                <label class="vs-input--label">Ngày bắt đầu</label>
                <span class="text-danger">*</span>
                <datepicker :highlighted="highlightedFn" :language="vi"
                            :format="'dd/MM/yyyy'" v-model="holiday.fromDate" data-vv-validate-on="input"
                            v-validate="'required'" name="fromDate" @input="checkDate">
                </datepicker>
                <span class="text-danger text-sm">{{ errors.first('fromDate') }}</span>
            </div>
            <div class="vx-col w-full md:w-1/3 mt-2">
                <label class="vs-input--label">Ngày kết thúc</label>
                <span class="text-danger">*</span>
                <datepicker :highlighted="highlightedFn" :format="'dd/MM/yyyy'"
                            :language="vi" v-model="holiday.toDate" data-vv-validate-on="input" v-validate="'required'"
                            name="toDate" @input="checkDate"></datepicker>
                <span class="text-danger text-sm">{{ errors.first('toDate') }}</span>
            </div>
        </div>
        <div class="vx-row mt-2">
            <div class="vx-col w-full mt-2">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" color="primary" @click="saveHoliday" :disabled="!validateForm"
                               v-if="(!isUpdate && isPermissionAdd) || (isUpdate && isPermissionUpdate)">
                        {{ `${isUpdate ? 'Cập nhật' : 'Tạo mới'}` }}
                    </vs-button>
                    <vs-button class="ml-4 mt-2" color="primary" type="border" onclick="history.back()">Quay lại
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {en, vi} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import {isAPI} from '../../../../store/permission';
import {constAPI} from '../../../../store/constant';

export default {
    components: {
        vSelect,
        Datepicker,
    },

    data() {
        return {
            userInfo: {},
            branchOptions: [],
            holiday: {},
            isUpdate: false,
            block: true,
            en: en,
            vi: vi,
            highlightedFn: {
                customPredictor(date) {
                    if (moment(new Date()).format('YYYY-MM-DD') == moment(new Date(date)).format('YYYY-MM-DD')) {
                        return true;
                    }
                }
            },
            disabledDates: {
                customPredictor(date) {
                    date = new Date(date);
                    date.setDate(date.getDate() - 1);
                    if (moment(date).isBefore(moment(), 'days')) {
                        return true;
                    }
                }
            },

        }
    },

    created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });

        this.branchModel = this.branchOptions[0]

        let holidayId = this.$route.query.id;
        if (holidayId) {
            this.isUpdate = true;
            this.getHolidayInfo(holidayId);
        }
    },

    computed: {

        validateForm() {
            return !this.errors.any()
        },

        branchModel: {
            get() {
                let x = this.branchOptions.find(item => item.value == this.holiday.organizationBranchId);
                if (!x) {
                    return
                }
                return {
                    label: x.label,
                    value: x.id
                }
            },
            set(obj) {
                this.holiday.organizationBranchId = obj.value;
            },
        }
    },


    methods: {
        isPermissionAdd() {
            return isAPI(this, constAPI.holiday_add)
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.holiday_update)
        },

        checkDate() {
            let fromDate = new Date(this.holiday.fromDate);
            let toDate = new Date(this.holiday.toDate);
            if (moment(fromDate) > moment(toDate)) {
                this.$vs.notify({
                    text: 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
                return false;
            }
            return true;
        },

        async saveHoliday(el) {
            el.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;
            if (!this.checkDate()) return;

            this.$vs.loading();
            this.holiday.holidayDate = this.holiday.fromDate;
            let url = this.isUpdate ? `/holiday/update/${this.holiday.id}` : `/holiday/create/${this.holiday.organizationBranchId}`;
            let data = this.isUpdate ? this.holiday : [this.holiday];
            this.$crm.post(url, data).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} thông tin ngày nghỉ thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                this.$vs.loading.close();
                setTimeout(() => {
                    history.back();
                }, 1000)
            }).catch(error => {
                this.$vs.notify({
                    title: 'Lỗi',
                    text: error.response.data.message,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$vs.loading.close();
                if (error.response.status === 401) {
                    localStorage.clear();
                    return this.$router.push("/pages/login");
                }
            })
                .finally(() => {
                });
        },

        getHolidayInfo(holidayId) {
            this.$vs.loading();
            this.$crm.post('/holiday/find-by-id/' + holidayId).then((response) => {
                this.holiday = response.data;
                this.isUpdate = true;
                this.$vs.loading.close();
            }).catch((error) => {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: 'Lỗi',
                    text: error.response.data.message,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            });

        },
    }
}
</script>
